// extracted by mini-css-extract-plugin
export default {"mosaic":"N6V1MdbejKAqE8vk0Zmo","mosaicCell":"k4FdhKI1s44dP76jjdAQ","mosaicFallback":"hEooAmSOmkTYaKY3hrIz"};